function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        return false; // Chrome
      } else {
        return true; // Safari
      }
    }
    return false;
  }
  
  function scrollToElement(quantity) {
    window.scrollTo({
      top: quantity - 20,
      left: 100,
      behavior: "smooth",
    });
  }
  
  function animationScroll(element) {
    let counter = 0;
  
    let interval = setInterval(() => {
      scrollToElement(counter);
      counter += 50;
  
      if (counter >= element.offsetTop) clearInterval(interval);
    }, 10);
  }